import React, { Component } from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import LoadingOverlay from './LoadingOverlay';

const INSPECTION_ACTIVITY_QUERY = gql`
  query StatsInspectionActivity {
    inspectionActivity: stats_inspection_activity {
      personId: person_id
      firstName: first_name
      lastName: last_name
      count7: count_7
      count14: count_14
      count30: count_30
    }
  }
`;

class InspectionActivityChart extends Component {
  render() {
    return (
      <Query query={INSPECTION_ACTIVITY_QUERY}>
        {({ loading, error, data }) => (
          <Card>
            <CardHeader>
              <strong>Inspection Activity by Person - Top 10</strong>
            </CardHeader>
            <CardBody style={{ position: 'relative', minHeight: '150px' }}>
              {loading && <LoadingOverlay />}
              {error && <div>Error: {error.message}</div>}
              {!loading && !error && data && (
                <Table size="sm" responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th className="text-center">7d</th>
                      <th className="text-center">14d</th>
                      <th className="text-center">30d</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.inspectionActivity.map((person, idx) => (
                      <tr key={idx}>
                        <td>{person.firstName} {person.lastName}</td>
                        <td className="text-center">{person.count7}</td>
                        <td className="text-center">{person.count14}</td>
                        <td className="text-center">{person.count30}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        )}
      </Query>
    );
  }
}

export default InspectionActivityChart;



// WEBPACK FOOTER //
// ./src/views/Dashboard/InspectionActivityChart.js